<template lang="pug">
.section
  .section-header
    h1 {{ $t("ui.theme_content_position") }}
  .section-body(style="max-width:600px;")
    .row
      .col-12
        .card.mb-0
          .card-header
            .row.col-12
              .form-group.col-6.mb-1
                SubmitButton(
                  :loading="loading"
                  icon="fa fa-retweet"
                  :text="$t('ui.refresh')"
                  type="button"
                  @click="getThemeContentPositionList()"
                  variant="primary"
                  size="sm"
                )

          .card-body
            .row
              .col-12
                .clusterize-scroll.table-responsive
                  table.table.table-sm.table-bordered.table-striped.table-hover
                    thead.thead-light
                      tr
                        th.text-center(width="3%")
                          span #
                        th
                          span(:title="$t('ui.theme_content_position')") {{ $t('ui.theme_content_position') }}

                    tbody.clusterize-content
                      tr(v-if="themeContentPositionList.length == 0")
                        td(colspan="3").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in themeContentPositionList")
                        td.text-center
                          span(:title="index + 1") {{ index + 1 }}
                        td
                          span(:title="item.position") {{ item.position }}


</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";

export default {
  components: {
    SubmitButton
  },
  data: () => ({
    loading: false,
    themeContentPositionList: [],
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
  }),
  computed: {
    accountType() {
      return this.$store.getters.accountType;
    },
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    }
  },
  mounted: function() {
    this.getThemeContentPositionList();
  },
  methods: {
    getThemeContentPositionList: function() {
      let url = config.getThemeContentPositionListUrl();

      var json = {
        auth_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.loginId,
      }

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;

              if (this.feedback.success == true) {
                this.themeContentPositionList = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>